import React from 'react';

export const ModalDialogContext = React.createContext();
